import React, { useEffect, useState } from 'react';
import CustomModal from '../CustomModal';
import moment from 'moment';
import { createAppoinmentScheduleofProvider, onAuthStateChanged } from '../../../store/actions';
import { firestoreOperationsDb } from '../../../firebase';
import Loader from '../../Loader';
import ProfileCard from './Common/ProfileCard';
import ExclusiontList from './Common/ExclusiontList';
import AdditionList from './Common/AdditionList';
import WeeklyScheduleList from './Common/WeeklyScheduleList';
import AddScheduleTime from './Common/AddScheduleTime';
import AddDateRange from './Common/AddDateRange';
import AddExclusionDate from './Common/AddExclusionDate';
import firebase from 'firebase';
import ScheduleWithAdditionExclusion from './ScheduleWithAdditionExclusion';

const AppointmentSchedule = ({ setShowEditAppointmentModal }) => {
  const [weeklySchedule, setWeeklySchedule] = useState([
    { day: 'S', times: [], active: false },
    { day: 'M', times: [], active: false },
    { day: 'T', times: [], active: false },
    { day: 'W', times: [], active: false },
    { day: 'Th', times: [], active: false },
    { day: 'F', times: [], active: false },
    { day: 'S', times: [], active: false },
  ]);

  const [additions, setAdditions] = useState([]); // Additional available date ranges
  const [exclusions, setExclusions] = useState([]); // Excluded specific dates
  const [userId, setUserId] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(async (error,user) => {
      if (error) {
        console.error("Auth state error:", error);
        return;
      }
      if (user) {
        debugger
        setUserId(user.uid);
        
        try {
          const userRef = firestoreOperationsDb.collection('users').doc(user.uid);
          const userSnap = await userRef.get();

          if (userSnap.exists) {
            const userData = userSnap.data();
            setUserInfo(userData);
          }

          // Fetch weekly schedule
          const weeklyRef = firestoreOperationsDb.collection('users').doc(user.uid).collection('schedules').doc('weekly');
          const weeklySnap = await weeklyRef.get();
          if (weeklySnap.exists) {
            const data = weeklySnap.data();
            setWeeklySchedule(data.days || weeklySchedule);
          }

          // Fetch additions
          const additionsRef = firestoreOperationsDb.collection('users').doc(user.uid).collection('schedules').doc('additions');
          const additionsSnap = await additionsRef.get();
          if (additionsSnap.exists) {
            setAdditions(additionsSnap.data().ranges || []);
          }

          // Fetch exclusions
          const exclusionsRef = firestoreOperationsDb.collection('users').doc(user.uid).collection('schedules').doc('exclusions');
          const exclusionsSnap = await exclusionsRef.get();
          if (exclusionsSnap.exists) {
            setExclusions(exclusionsSnap.data().dates || []);
          }
        } catch (error) {
          console.error('Error fetching appointment schedule:', error);
        } finally {
          setFetching(false); // Stop fetching indicator
        }
      } else {
        setUserId(null);
        setUserInfo(null);
        setFetching(false);
      }
    });
    // return () => unsubscribe && unsubscribe();
  }, []);

  
  const handleSaveAppoinment = async () => {
    setLoading(true);
    await createAppoinmentScheduleofProvider(weeklySchedule, additions, exclusions, userId, setLoading);
  };


  return (
    <div className="appointment-container">
      <div className="schedule-card" style={{ borderRadius: '0px'}}>
        {(loading || fetching) && (
          <div className="loader-overlay">
            <div className="loader-content">
              <Loader />
            </div>
          </div>
        )}
        
        <ScheduleWithAdditionExclusion 
          setExclusions={setExclusions} 
          setAdditions={setAdditions}
          setWeeklySchedule={setWeeklySchedule}
          additions={additions}
          exclusions={exclusions}
          weeklySchedule={weeklySchedule}
          userInfo={userInfo}
        />

        <div style={{display: 'flex',justifyContent: 'center',gap: '10px', padding: '15px 20px', borderTop: '1px solid #eee'}}>
          <button 
            className="btn-cancel"
            onClick={() => setShowEditAppointmentModal(false)}
          >
            Cancel
          </button>
          <button 
            className="btn-save"
            onClick={handleSaveAppoinment}
            disabled={loading}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppointmentSchedule;